"use client";

import React from "react";
import { LocaleLink as Link } from "@/components/shared/LocaleLink";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal } from "@/components/shared/motion";
import { Smartphone, ArrowRight } from "lucide-react";

/**
 * WanderLite compatibility teaser — a warm soft-white card nudging beginners to
 * the device checker. Rounded-full pill CTA to the shared /compatible-phones/
 * page. No glass, no gradients.
 */
export default function CompatTeaser() {
  const { t } = useTranslations();

  return (
    <section className="container mx-auto px-4 py-10">
      <Reveal as="div" className="wander-card flex flex-col items-center gap-5 p-8 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left" y={18}>
        <div className="flex flex-col items-center gap-4 sm:flex-row">
          <span className="wander-chip inline-flex h-14 w-14 shrink-0 items-center justify-center">
            <Smartphone className="h-6 w-6" />
          </span>
          <div>
            <div className="text-lg font-semibold text-foreground">
              {t("wander.compat.title", "Will your phone work with an eSIM?")}
            </div>
            <p className="mt-1 text-sm text-muted-foreground">
              {t("wander.compat.body", "Most recent phones do. Check yours in a few seconds before you buy.")}
            </p>
          </div>
        </div>
        <Link
          href="/compatible-phones/"
          className="inline-flex shrink-0 items-center gap-2 rounded-full bg-primary px-6 py-3 font-semibold text-white shadow-sm transition-all active:scale-[0.98] hover:bg-primary/90"
        >
          {t("wander.compat.cta", "Check my device")}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
    </section>
  );
}
